import { render } from "./Friend.vue?vue&type=template&id=061f5840&scoped=true"
import script from "./Friend.vue?vue&type=script&lang=js"
export * from "./Friend.vue?vue&type=script&lang=js"

import "./Friend.vue?vue&type=style&index=0&id=061f5840&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\areaclienti.luceegasitalia.it\\areaclienti\\areaclienti\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-061f5840"]])

export default __exports__